// extracted by mini-css-extract-plugin
module.exports = {"Question":"Question_Question__gyQXk","Priority":"Question_Priority__Vqet3"};